import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    timeOut: any;
}
const initialState: InitialState = {
    timeOut: sessionStorage.getItem("timeOut"),
};

export const systemReducer = createSlice({
    name: "system",
    initialState,
    reducers: {
        autoLogout: (state, action) => {
            state.timeOut = action.payload;
            sessionStorage.setItem("timeOut", state.timeOut);
        }
    },
});

export const { autoLogout } =
    systemReducer.actions;

export default systemReducer.reducer;

